const KEYBOARD_STEP = 10;
const KEYBOARD_PAGE_STEP = 50;

interface UseKeyboardResizeOptions {
  clamp: (value: number) => number;
  direction: 1 | -1;
  maxWidth?: number;
  minWidth: number;
  onResize: (width: number) => void;
  width: number;
}

const getStepForKey = (key: string): number => {
  if (key === "ArrowLeft" || key === "ArrowRight") return KEYBOARD_STEP;
  if (key === "PageUp" || key === "PageDown") return KEYBOARD_PAGE_STEP;
  return 0;
};

export function useKeyboardResize({
  width,
  direction,
  clamp,
  minWidth,
  maxWidth,
  onResize,
}: UseKeyboardResizeOptions) {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    if (e.key === "Home") {
      e.preventDefault();
      onResize(minWidth);
      return;
    }
    if (e.key === "End" && maxWidth !== undefined) {
      e.preventDefault();
      onResize(maxWidth);
      return;
    }
    const step = getStepForKey(e.key);
    if (step === 0) return;
    e.preventDefault();
    const sign = e.key === "ArrowRight" || e.key === "PageUp" ? 1 : -1;
    onResize(clamp(width + direction * sign * step));
  };

  return { handleKeyDown };
}
